import { IPropPageSeo } from '@ucheba/utils/helpers/components/types'
import { SetStateAction } from 'react'

export interface IPlannerProgramsPageProps {
  content: IContent
  canonical?: string | undefined
}

interface IContent extends IPropPageSeo {}

export enum EQueryParams {
  isVuzGroup = 'isVuzGroup',
}

export interface IPlannerProgramsButtonSetter {
  setState?: SetStateAction<any>
}

export interface IPlannerProgramsPageCheck {
  isVuzType: boolean
}

export interface IPlannerProgramsPageBannerParams {
  onOpenEgeDialogClick(): void
}
